import { render, staticRenderFns } from "./TriviaCard.vue?vue&type=template&id=c4156c3e&scoped=true&"
import script from "./TriviaCard.vue?vue&type=script&lang=js&"
export * from "./TriviaCard.vue?vue&type=script&lang=js&"
import style0 from "./TriviaCard.vue?vue&type=style&index=0&id=c4156c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4156c3e",
  null
  
)

export default component.exports